<template>
    <div class="draggable-item" :class="{'read-only': !readOnly}">
        <span class="draggable-arrow-wrapper" v-show="isExpandable">
            <icon v-if="!expanded && 'Device' !== `${value.type}`" icon="arrow-right" color="#D4D4D4" class="draggable-arrow"></icon>
            <icon v-if="expanded && 'Device' !== `${value.type}`" icon="arrow-down" color="#D4D4D4" class="draggable-arrow"></icon>
        </span>
        <span class="draggable-arrow-wrapper" v-show="!isExpandable"></span>

        <span class="draggable-main-icon">
            <icon v-if="'Organization' ===`${value.type}`" icon="suitcase" color="#fff" class="draggable-icon"></icon>
            <icon v-if="'Fleet' ===`${value.type}`" icon="truck-solid" color="#fff" class="draggable-icon"></icon>
            <icon v-if="'Vehicle' ===`${value.type}`" icon="event-car" color="#fff" class="draggable-icon"></icon>
            <icon v-if="'Device' ===`${value.type}`" icon="device" color="#fff" class="draggable-icon"></icon>
        </span>

        <span class="draggable-name">{{ value.name }}</span>

        <item-organization v-if="'Organization' ===`${value.type}`" :value="value"></item-organization>

        <item-fleet v-if="'Fleet' ===`${value.type}`" :value="value"></item-fleet>

        <item-vehicle v-if="'Vehicle' ===`${value.type}`" :value="value"></item-vehicle>

        <item-device v-if="'Device' ===`${value.type}`" :value="value"></item-device>

        <span class="draggable-icon--edit" v-if="readOnly" @click="handleReassignItem">
            <icon icon="go-to" color="#fff" ></icon>
        </span>

    </div>
</template>

<script>
import Icon from '@/components/atoms/Icon'
import TreeViewItemOrganization from '@/views/Tree/TreeViewItemOrganization'
import TreeViewItemFleet from '@/views/Tree/TreeViewItemFleet'
import TreeViewItemVehicle from '@/views/Tree/TreeViewItemVehicle'
import TreeViewItemDevice from '@/views/Tree/TreeViewItemDevice'

export default {
    name: 'TreeViewItem',
    components: {
        Icon,
        'item-organization': TreeViewItemOrganization,
        'item-fleet': TreeViewItemFleet,
        'item-vehicle': TreeViewItemVehicle,
        'item-device': TreeViewItemDevice,
    },
    data () {
        return {
            itemModal: false,
            isDropOptionChoose: true,
            reassignItemModalOpen: false
        }
    },
    props: {
        value: {
            type: Object
        },
        expanded: {
            type: Boolean
        },
        readOnly: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        isExpandable () {
            return 0 < this.value.items.length
        }
    },
    watch: {
        value () {
            if (this.value) {
                this.isDropOptionChoose = false
            }
        }
    },
    methods: {
        handleReassignItem () {
            this.$emit('handleReassignItem', this.value)
        }
    }
}
</script>

<style scoped lang="scss">
.draggable-item {
    display: flex;
    align-items: center;
    box-shadow: 0 2px 6px $inactive;
    margin-bottom: 10px;
    border-radius: 6px;
    padding-left: 5px;
    cursor: pointer;
}

.draggable-arrow-wrapper {
    min-width: 22px;
}

.draggable-arrow {
    margin: 0 3px;

    @media (min-width: 1200px) {
        margin: 9px 12px 9px 7px;
    }
}

.draggable-main-icon {
    width: 30px;
}

.draggable-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-wrap: wrap;
    width: 40%;
    margin-right: 10px;

    @media (min-width: 992px) {
        width: 51%;
    }

    @media (min-width: 1200px) {
        width: 50%;
        margin-left: auto;
    }

    @media (min-width: 1440px) {
        width: 51%;
    }
}

.draggable-icon {
    display: flex;
    background-color: $secondary-default;
    padding: 5px;
    height: 25px;
    width: 30px;
    border-radius: 7px;

    @media (min-width: 1200px) {
        height: 30px;
        width: 40px;
    }

    &--edit {
        display: flex;
        background-color: $secondary-default;
        margin-left: auto;
        align-items: center;
        padding: 0 10px;
        justify-content: center;
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
        height: 54px;
        transition: opacity 0.3s;

        @media (min-width: 1200px) {
            padding: 0 13px;
        }

        @media (min-width: 1440px) {
            padding: 0 15px;
        }

        &:hover {
            opacity: 0.5;
        }
    }
}

.draggable-name {
    font-size: 12px;
    margin-left: 5px;
    width: 40%;
    overflow-x: hidden;
    text-overflow: ellipsis;

    @media (min-width: 992px) {
        width: 35%;
    }

    @media (min-width: 1200px) {
        font-size: 16px;
        margin-left: 20px;
        width: 40%;
    }
}

.device {
    .draggable-arrow-wrapper {
        min-width: 15px;

        @media (min-width: 1200px) {
            min-width: 22px;
        }
    }

    .draggable-name {
        width: 80%;
    }

    .draggable-icon-wrapper {
        display: none;
    }
}

.isMenuActive .tree {
    @media (min-width: 1200px) {
        .draggable-arrow {
            margin: 0 3px;
        }

        .draggable-icon-wrapper {
            width: 40%;
            margin-right: 10px;
        }

        .draggable-icon {
            height: 25px;
            width: 30px;

            &--edit {
                padding: 0 10px;
            }
        }

        .draggable-name {
            font-size: 12px;
            margin-left: 5px;
            width: 30%;
            overflow-x: hidden;
            text-overflow: ellipsis;
        }

        .device {
            .draggable-arrow-wrapper {
                min-width: 15px;
            }
            .draggable-icon-wrapper {
                display: none;
            }
            .draggable-name {
                width: 40%;
            }
        }

        .fleet {
            .draggable-name {
                width: 50%;
            }
        }

        .vehicle {
            .draggable-name {
                width: 50%;
            }
        }
    }

    @media (min-width: 1440px) {
        .draggable-icon-wrapper {
            width: 69%;
        }
    }

    @media (min-width: 1700px) {
        .draggable-name {
            font-size: 16px;
            margin-left: 15px;
            width: 40%;
        }
        .draggable-icon {
            height: 30px;
            width: 40px;
            margin-left: 2px;

            &--edit {
                padding: 0 15px;
            }
        }
    }
}

.read-only {
    width: 80%;
    height: 35px;
    margin: 10px auto;

    @media (min-width: 1200px) {
        height: auto;
        min-height: 54px;
    }
}
</style>
